import React from 'react'
import { Link, ChatIcon } from '@paypalcorp/pp-react'
import PropTypes from 'prop-types'
import styles from './feedback_link.less'
import { getI18n } from 'client/i18n'

export const I18N_CONTEXT = 'components/pages/crowdfunding/pool_share'
const i18n = getI18n(I18N_CONTEXT)

const propTypes = {
  activeFeedbackName: PropTypes.string,
  reloadQualtrics: PropTypes.function,
  uniqueFeedbackName: PropTypes.string,
}

const FeedbackLink = ({
  activeFeedbackName,
  reloadQualtrics,
  uniqueFeedbackName,
}) => {
  const handleClick = e => {
    e.preventDefault()
    reloadQualtrics(uniqueFeedbackName)
  }

  // activeFeedback is called once on page load, to manually trigger call for
  // survey but it will only open when qualtrics config allows which is currently
  // set to 10%
  React.useEffect(() => {
    reloadQualtrics(activeFeedbackName)
  }, [])

  return (
    <div className={styles.feedbackLink}>
      <ChatIcon size="sm" />
      <Link href="/" onClick={handleClick}>
        {i18n('feedback_link')}
      </Link>
    </div>
  )
}

FeedbackLink.propTypes = propTypes
export default FeedbackLink
